import { render, staticRenderFns } from "./LinkTenantSettingTitle.vue?vue&type=template&id=791e07e5&scoped=true"
import script from "./LinkTenantSettingTitle.vue?vue&type=script&lang=js"
export * from "./LinkTenantSettingTitle.vue?vue&type=script&lang=js"
import style0 from "./LinkTenantSettingTitle.vue?vue&type=style&index=0&id=791e07e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791e07e5",
  null
  
)

export default component.exports